import {
  globalDeleteService,
  globalGetService,
  globalPutService,
} from '@/utils/globalApiServices';
import { User } from './types';

export const getUsers = async (): Promise<User[]> => {
  const response = await globalGetService('csp/manage/users');
  return response?.ok ? response.data : [];
};

export const getRoles = async (
  type?: 'PRIMARY' | 'SECONDARY'
): Promise<string[]> => {
  const params = type ? { type } : {};
  const response = await globalGetService('csp/manage/users/roles', params);
  return response?.ok ? response.data : [];
};

export const createUser = async (data = {}) => {
  const response = await globalPutService('csp/manage/users', data);
  return response?.ok ? data : undefined;
};

export const updateUser = async (id: string, data = {}) => {
  const response = await globalPutService(`csp/manage/users/${id}`, data);
  return response?.ok ? data : undefined;
};

export const deleteUser = async (id: string) => {
  const response = await globalDeleteService(
    `csp/manage/users/${id}/remove`,
    {}
  );
  return response?.ok ? id : undefined;
};
